<template>
  <div class="home">
    <!-- 自定义内容区域 -->
    <div class="header">
      <p class="desc">{{ indexCarousel }}</p>
      <img class="rightImg" src="../assets/home-imgs/bgc01.png" alt="" />
      <img class="leftImg" src="../assets/home-imgs/bgc2.png" alt="" />
    </div>
    <div class="rank">
      <div class="title">
        <div class="left">
          <img style="width: 22px" src="../assets/home-imgs/ZS排行2.svg" alt="" />
          <div>业绩排行</div>
        </div>
        <!-- <div class="more" @click="handleGoRank">更多</div> -->
      </div>
      <div class="rank-list" @mouseover="overFn" @mouseout="outFn">
        <swiper v-if="voList && voList.length > 0" :options="swiperOption" class="swiperbox">
          <swiper-slide v-for="(v, i) in voList" :key="i">
            <div class="item" v-if="v">
              <img
                class="img"
                width="66"
                height="90"
                style="border-radius: 50%"
                :src="v.avatar ? v.avatar : imgUrl"
                alt=""
              />
              <span class="name-box">{{ v.userName }}</span>
              <span class="price">￥{{ v.receivableAmount }}</span>
              <div class="hat-box" v-if="i < 3">
                <img class="hat" :src="require('../assets/home-imgs/皇冠VIP' + (i + 1) + '.svg')" alt="" />
              </div>
            </div>
            <div class="item" v-else>
              <a-skeleton
                :avatar="{ size: 80, shape: 'circle' }"
                :title="1 === 2"
                :paragraph="{ rows: 2, width: '100%' }"
                style="
                  height: 150px;
                  display: flex;
                  flex-direction: column;
                  justify-content: space-between;
                  align-items: center;
                "
              />
            </div>
          </swiper-slide>

          <!-- <swiper-slide v-if="voList[0]">
            <div class="item">
              <img
                class="img"
                width="66"
                height="90"
                style="border-radius: 50%"
                :src="voList[0].avatar ? voList[0].avatar : imgUrl"
                alt=""
              />
              <span class="name-box">{{ voList[0].userName }}</span>
              <span class="price">￥{{ voList[0].receivableAmount }}</span>
              <div class="hat-box">
                <img class="hat" src="../assets/home-imgs/皇冠VIP1.svg" alt="" />
              </div>
            </div>
          </swiper-slide>
          <swiper-slide v-if="voList[1]">
            <div class="item">
              <img
                class="img"
                width="66"
                height="90"
                style="border-radius: 50%"
                :src="voList[1].avatar ? voList[1].avatar : imgUrl"
                alt=""
              />
              <span class="name-box">{{ voList[1].userName }}</span>
              <span class="price">￥{{ voList[1].receivableAmount }}</span>
              <div class="hat-box">
                <img class="hat" src="../assets/home-imgs/皇冠VIP2.svg" alt="" />
              </div>
            </div>
          </swiper-slide>
          <swiper-slide v-if="voList[2]">
            <div class="item">
              <img
                class="img"
                width="66"
                height="90"
                style="border-radius: 50%"
                :src="voList[2].avatar ? voList[2].avatar : imgUrl"
                alt=""
              />
              <span class="name-box">{{ voList[2].userName }}</span>
              <span class="price">￥{{ voList[2].receivableAmount }}</span>
              <div class="hat-box">
                <img class="hat" src="../assets/home-imgs/皇冠VIP3.svg" alt="" />
              </div>
            </div>
          </swiper-slide>

          <swiper-slide v-for="(v, i) in lastList()" :key="i">
            <div class="item">
              <img
                class="img"
                width="66"
                height="90"
                style="border-radius: 50%"
                :src="v.avatar ? v.avatar : imgUrl"
                alt=""
              />
              <span class="name-box">{{ v.userName }}</span>
              <span class="price">￥{{ v.receivableAmount }}</span>
            </div>
          </swiper-slide> -->
        </swiper>
        <swiper v-else :options="swiperOption" class="swiperbox">
          <swiper-slide v-for="(v, i) in 10" :key="i">
            <div class="item">
              <a-skeleton
                :avatar="{ size: 80, shape: 'circle' }"
                :title="1 === 2"
                :paragraph="{ rows: 2, width: '100%' }"
                style="
                  height: 150px;
                  display: flex;
                  flex-direction: column;
                  justify-content: space-between;
                  align-items: center;
                "
              />
            </div>
          </swiper-slide>
        </swiper>
        <!-- <div class="swiper-button-prev" :class="{ over: isover }"></div> -->
        <!--左箭头。如果放置在swiper外面，需要自定义样式。-->
        <!-- <div class="swiper-button-next" :class="{ over: isover }"></div> -->
        <!--右箭头。如果放置在swiper外面，需要自定义样式。-->
      </div>
    </div>

    <div class="statistics-userInfo">
      <div class="statistics">
        <div class="title">
          <div class="title-left">
            <img style="width: 22px" src="../assets/home-imgs/创新验证.svg" alt="" />
            <div>数据统计</div>
          </div>
          <a-select class="title-right" default-value="本月" style="width: 90px" @change="achievementDate">
            <a-select-option value="本周"> 本周 </a-select-option>
            <a-select-option value="本月"> 本月 </a-select-option>
            <a-select-option value="本季"> 本季 </a-select-option>
            <a-select-option value="本年"> 本年 </a-select-option>
          </a-select>
        </div>
        <div class="content">
          <div class="item">
            <div class="img-box">
              <img class="img" src="../assets/home-imgs/新增房源.svg" alt="" />
            </div>
            <div class="right">
              <p>
                <span>{{ radar.addHouse ? radar.addHouse : '0' }}</span
                >套/{{ dateName }}
              </p>
              <h3>新增房源量</h3>
            </div>
          </div>
          <div class="item">
            <div class="img-box">
              <img class="img" src="../assets/home-imgs/新增客源.svg" alt="" />
            </div>
            <div class="right">
              <p>
                <span>{{ radar.addGuest ? radar.addGuest : '0' }} </span>人/{{ dateName }}
              </p>
              <h3>新增客源量</h3>
            </div>
          </div>
          <div class="item">
            <div class="img-box">
              <img class="img" src="../assets/home-imgs/带看数量.svg" alt="" />
            </div>
            <div class="right">
              <p>
                <span>{{ radar.takeLookCount ? radar.takeLookCount : '0' }} </span>个/{{ dateName }}
              </p>
              <h3>带看数量</h3>
            </div>
          </div>
          <div class="item">
            <div class="img-box">
              <img class="img" src="../assets/home-imgs/签单数量.svg" alt="" />
            </div>
            <div class="right">
              <p>
                <span>{{ radar.signOrders ? radar.signOrders : '0' }} </span>单/{{ dateName }}
              </p>
              <h3>签单数量</h3>
            </div>
          </div>
              <div class="item">
            <div class="img-box">
              <img class="img" src="../assets/home-imgs/成交金额.svg" alt="" />
            </div>
            <div class="right">
              <p v-if="radar.receivableAmount">
                <span
                >{{
                  radar.receivableAmount > 999 ? (radar.receivableAmount / 10000).toFixed(2) : radar.receivableAmount
                }} </span
                >{{ radar.receivableAmount > 999 ? '万元' : '元' }}/{{ dateName }}
              </p>
              <p v-else><span>0</span>元/{{ dateName }}</p>
              <h3>个人业绩</h3>
            </div>
          </div>
        </div>
      </div>
      <div class="userInfo">
        <div class="item-p">
          <div class="title">
            <img style="width: 22px" src="../assets/home-imgs/创新验证.svg" alt="" />
            <div>个人能力</div>
          </div>
          <div class="radar-box" id="radar"></div>
        </div>
        <div class="item">
          <img width="80" style="border-radius: 50%" :src="avatar ? avatar : imgUrl" alt="" />
          <div style="display: flex">
            <span style="margin-top: 10px; font-size: 16px; font-weight: 700">
              {{
                userInfo.nickName && userInfo.nickName.length > 7
                  ? userInfo.nickName.substr(0, 7) + '...'
                  : userInfo.nickName
              }}
            </span>
            <a-tag
              color="green"
              style="height: 20px; margin-top: 12px; margin-left: 6px"
            >{{
              $getters.userInfo.position === '0' && $getters.userInfo.admin
                ? '超级管理员'
                : $getters.userInfo.position === '1'
                  ? '店长'
                  : $getters.userInfo.position === '2'
                    ? '组长'
                    : '店员'
            }}
            </a-tag>
          </div>
          <span style="font-size: 14px; font-weight: 700; margin-top: 10px">{{ userInfo.deptName }}</span>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="left">
        <div class="title">
          <img style="width: 22px" src="../assets/home-imgs/目标管理.svg" alt="" />
          <div>目标管理</div>
        </div>
        <div id="echarts" class="echarts"></div>
      </div>
      <div class="right">
        <div class="title">
          <img style="width: 22px" src="../assets/home-imgs/热度.svg" alt="" />
          <div>房源热度</div>
        </div>
        <div class="content" v-if="houseLookHotList && houseLookHotList.length">
          <div class="lookItem" style="display:flex" v-for="(v, i) in houseLookHotList" :key="v.id">
           <div :style="{ width: hotWidthList[i]-10 + '%' }" >
             <div class="itemList" :title="v.shopName" @click="handleOneHouse(v.id)">
             
            </div>
           </div>
            <div style="display:flex" class="itemListright">
              <div >{{  text((v.lookHot+ v.shopName),hotWidthList[i]) }}</div>
            </div>
          </div>
        </div>
        <div class="content" v-else>
          <div class="lookItem" v-for="(v, i) in 15" :key="i">
            <a-skeleton :paragraph="{ rows: 1, width: 400 }" :title="false" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { timeFix } from '@/utils/util'
import { mapGetters } from 'vuex'
import { PageHeaderWrapper } from '@/components/ProLayout'
import { getUserProfile } from '@/api/system/user'
import homeApi from '@/api/system/home/home.js'
import 'swiper/css/swiper.min.css'
import { getYMDHMS, getCurrentDate, getBeginWeek, getBeginMonth, getquarterDay, getYearFirstDay } from '@/utils/date'

export default {
  name: 'Index',
  components: {
    PageHeaderWrapper
  },
  data () {
    return {
      ismodal: false,
      isover: false,
      imgUrl: require('@/assets/home-imgs/头像.svg'),
      noTitleKey: 'RuoYi',
      timeFix: timeFix(),
      // 用户信息
      user: {
        dept: {
          deptName: ''
        }
      },
      // 统计数据-参数
      statistic: {
        startDate: getYMDHMS('/', ':', getBeginMonth()),
        endDate: getYMDHMS('/', ':', getCurrentDate())
      },
      dateName: '月',
      guestFallPlateCount: 0, // 客源即将掉盘
      houseFallPlateCount: 0, // 房源即将掉盘
      voList: [], // 业绩排行
      indexCarousel: '', // 轮播文字
      targetObj: {},
      messagesVo: {}, // 签约喜报
      sysNotice: {}, // 公告

      // 轮播
      swiperOption: {
        // notNextTick: true,
        autoplay: false,
        // speed: 2000,
        loop: false,
        // slidesPerView: 9,
        spaceBetween: 10,
        slidesPerView: 10,
        // centeredSlides: true, // 设置活动块居中

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },

        freeMode: {
          momentumBounce: true
        }
      },
      // 字典表返回数据
      fileType: [],
      category: [],
      // 雷达数据
      radarRadius: document.body.clientWidth > 1700 ? 80 : 60, // 屏幕宽度
      radar: {
        addGuest: 0,
        addHouse: 0,
        receivableAmount: 0,
        signOrders: 0,
        takeLookCount: 0
      },
      userInfo: {},
      // 房源热度
      houseLookHotList: [],
      hotWidthList: []
    }
  },
  computed: {
    ...mapGetters(['avatar', 'nickname']),

    // 钥匙
    keysNum () {
      return this.targetObj.finishKeysNum + 'px'
    },
    targetKeysNum () {
      return this.targetObj.keysNum + 'px'
    },

    // 房增
    houseAdd () {
      return this.targetObj.finishHouseAdd + 'px'
    },
    targetHouseAdd () {
      return this.targetObj.houseAdd + 'px'
    },

    // 客增
    lesseeAdd () {
      return this.targetObj.finishLesseeAdd + 'px'
    },
    targetLesseeAdd () {
      return this.targetObj.lesseeAdd + 'px'
    },

    // 带看
    takeLook () {
      return this.targetObj.finishTakeLook + 'px'
    },
    targetTakeLook () {
      return this.targetObj.takeLook + 'px'
    },

    // 房源跟进
    houseFollowUp () {
      return this.targetObj.finishHouseFollowUp + 'px'
    },
    targetHouseFollowUp () {
      return this.targetObj.houseFollowUp + 'px'
    },

    // 客源跟进
    guestFollowUp () {
      return this.targetObj.finishGuestFollowUp + 'px'
    },
    targetGuestFollowUp () {
      return this.targetObj.guestFollowUp + 'px'
    },

    // 面访
    interview () {
      return this.targetObj.finishInterview + 'px'
    },
    targetInterview () {
      return this.targetObj.interview + 'px'
    }
  },

  methods: {
    text(text,num){
      // console.log(num,'num')
      if(num>80){
       return text.slice(0,3)+'...'
      }else{
         return text
      }
    },
    overFn () {
      this.isover = true
    },
    outFn () {
      this.isover = false
    },
    // 获取用户信息
    getUser () {
      getUserProfile().then((response) => {
        this.user = response.data
        this.roleGroup = response.roleGroup
        this.postGroup = response.postGroup
      })
    },
    onSponsorTabChange (key, type) {
      this[type] = key
    },

    // 自己写的js
    // 首页统计数据
    getStatistics () {
      homeApi.statistics({ ...this.statistic }).then((res) => {
        if (res.code === 200) {
          // 房源-客源即将进入公盘
          this.guestFallPlateCount = res.data.guestFallPlateCount
          this.houseFallPlateCount = res.data.houseFallPlateCount
          // 业绩排行
          this.voList = res.data.homePerformanceTopStatisticsVoList
          // this.voList = [
          //   { avatar: '', differenceAmount: 0.11, receivableAmount: 1, performanceTop: 1, userName: 'admin' },
          //   { avatar: '', differenceAmount: 0.11, receivableAmount: 1, performanceTop: 2, userName: 'admin' },
          //   { avatar: '', differenceAmount: 0.11, receivableAmount: 1, performanceTop: 3, userName: 'admin' },
          //   { avatar: '', differenceAmount: 0.11, receivableAmount: 1, performanceTop: 4, userName: 'admin' }
          //   ]
          if (this.voList != null && this.voList.length < 10) {
            const len = this.voList.length
            const forLen = 10 - len
            for (let i = 0; i < forLen; i++) {
              this.voList.push(null)
            }
          }

          // 轮播文字
          this.indexCarousel = res.data.indexCarousel
          // 目标及完成量
          this.targetObj = res.data.homeWorkProgressStatisticsVo
          this.messagesVo = res.data.messagesVo
          this.sysNotice = res.data.sysNotice
          this.$nextTick(() => {
            this.targetEchart(this.targetObj)
          })
          // 雷达数据
          this.radar = res.data.personalAbilityStatisticsVo
          // console.log(this.radarRadius)
          this.$nextTick(() => {
            this.radarEchart(this.radar, res.data.userInfoVo.nickName, this.radarRadius)
          })
          this.userInfo = res.data.userInfoVo // 个人信息
        }
      })
    },

    // 房源热度
    houseLookHot () {
      homeApi.houseLookHot().then((res) => {
        let hotCount = 0
        if (res.code === 200) {
          this.houseLookHotList = res.data
          // 获取热度数量
          const countArr = res.data.map((item) => {
            return item.lookHot
          })
          console.log(countArr)
          // 以热度总量为长度百分比
          // countArr.forEach((v) => {
          //   hotCount += v
          // })
          // 以热度最大值为长度百分比
          hotCount = Math.max(...countArr)
          // 计算百分比
          this.hotWidthList = countArr.map((item) => {
            return ((item / hotCount) * 100).toFixed(2)
          })
        }
      })
    },

    achievementDate (val) {
      if (val === '本周') {
        this.dateName = '周'
        this.statistic.startDate = getYMDHMS('/', ':', getBeginWeek())
        this.getStatistics()
      } else if (val === '本月') {
        this.dateName = '月'
        this.statistic.startDate = getYMDHMS('/', ':', getBeginMonth())
        this.getStatistics()
      } else if (val === '本季') {
        this.dateName = '季'
        this.statistic.startDate = getYMDHMS('/', ':', getquarterDay())
        this.getStatistics()
      } else if (val === '本年') {
        this.dateName = '年'
        this.statistic.startDate = getYMDHMS('/', ':', getYearFirstDay())
        this.getStatistics()
      }
    },
    // echarts适配窗口大小
    echartResize () {
      this.chart.resize() // 目标管理
      this.chart2.resize() // 雷达图
    },
    targetEchart (obj) {
      this.chart = this.$echarts.init(document.querySelector('#echarts'))
      const option = {
        legend: {
          data: ['进度', '目标'],
          orient: 'vertical',
          type: 'scroll',
          height: '80%',
          right: 30,
          top: 0,
          itemWidth: 36,
          itemHeight: 20,
          itemGap: 14
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        xAxis: {
          type: 'category',
          data: [
            '钥匙',
            '房增',
            '客增',
            '带看',
            '房源跟进',
            '客源跟进',
            '面访'
          ]
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '目标',
            data: [
              obj ? obj.keysNum : 100,
              obj ? obj.houseAdd : 100,
              obj ? obj.lesseeAdd : 100,
              obj ? obj.takeLook : 100,
              obj ? obj.houseFollowUp : 100,
              obj ? obj.guestFollowUp : 100,
              obj ? obj.interview : 100
            ],
            type: 'bar',
            // stack: 'one',
            color: '#1890ff',
            barMinWidth: 26,
            barMaxWidth: 30,
            barGap: 0
          },
          {
            name: '进度',
            data: [
              obj ? obj.finishKeysNum : 0,
              obj ? obj.finishHouseAdd : 0,
              obj ? obj.finishLesseeAdd : 0,
              obj ? obj.finishTakeLook : 0,
              obj ? obj.finishHouseFollowUp : 0,
              obj ? obj.finishGuestFollowUp : 0,
              obj ? obj.finishInterview : 0
            ],
            type: 'bar',
            // stack: 'one',
            color: '#52c41a',
            barMinWidth: 26,
            barMaxWidth: 30
          }
        ]
      }

      this.chart.setOption(option)

      // 监听事件
      window.addEventListener('resize', this.echartResize)
    },
    radarEchart (params, name, radarRadius) {
      const arrData = []
      Object.keys(params).forEach((key) => {
        arrData.unshift(params[key])
      })
      const maxData = Math.max(...arrData)
      this.chart2 = this.$echarts.init(document.querySelector('#radar'))
      const option = {
        tooltip: {
          trigger: 'axis'
        },
        radar: {
          indicator: [
            { text: '新增房源', max: maxData },
            { text: '新增客源', max: maxData },
            { text: '个人业绩', max: maxData },
            { text: '签单数量', max: maxData },
            { text: '带看数量', max: maxData }
          ],
          radius: radarRadius,
          center: ['50%', '57%']
        },
        series: [
          {
            type: 'radar',
            tooltip: {
              trigger: 'item'
            },
            itemStyle: {
              color: '#f37c4f'
            },
            lineStyle: {
              color: '#f5a080'
            },
            areaStyle: {
              color: '#f7bda7'
            },
            data: [
              {
                value: [
                  params.addHouse,
                  params.addGuest,
                  params.receivableAmount,
                  params.signOrders,
                  params.takeLookCount
                ],
                name: name
              }
            ]
          }
        ]
      }
      this.chart2.setOption(option)
      // 监听事件
      window.addEventListener('resize', this.echartResize)
      // 监听事件
      window.addEventListener('resize', this.radarRadiusFn)
    },
    radarRadiusFn () {
      this.radarRadius = document.body.clientWidth > 1700 ? 80 : 60
    },
    // 查询学习管理信息列表
    getLearnList () {
      const params = {
        pageNum: 1,
        pageSize: 10
      }
      homeApi.getLearnList(params).then((res) => {
        if (res.code === 200) {
          // this.$message.success('查询学习管理信息列表')
          this.learnList = res.data.records
        }
      })
    },

    lastList () {
      return [...this.voList].slice(3)
    },
    // 跳转排行榜详情
    handleGoRank () {
      this.$router.push('achievement/performanceList')
    },
    // 跳转房源详情
    handleOneHouse (id) {
      this.$router.push({
        path: '/houses/detail/index',
        query: { id: id }
      })
    }
  },

  watch: {
    radarRadius () {
      this.radarEchart(this.radar, this.userInfoVo && this.userInfoVo.nickName, this.radarRadius)
    }
  },

  created () {
    // 字典表
    this.getDicts('announcement_type').then((response) => {
      // console.log('announcement_type', response.data)
      this.fileType = response.data
    })
    this.getDicts('announcement_category').then((response) => {
      // console.log('announcement_category', response.data)
      this.category = response.data
    })

    this.getUser()
    this.getStatistics() // 首页统计数据
    this.getLearnList()
    this.houseLookHot()
  },

  beforeDestroy () {
    // 解绑事件
    window.removeEventListener('resize', this.echartResize)
    window.removeEventListener('resize', this.radarRadiusFn)
  }
}
</script>

<style>
.ant-skeleton-header {
  padding: 0;
}
</style>
<style lang="less" scoped>
// @import './index.less';

.home {
  .header {
    height: 160px;
    line-height: 160px;
    padding-left: 60px;
    font-size: 26px;
    color: #fff;
    background-image: linear-gradient(to right, #1890ff, #40a9ff);
    border-radius: 3px;
    position: relative;
    .rightImg {
      width: 180px;
      position: absolute;
      top: 60px;
      right: 12%;
    }
    .leftImg {
      height: 160px;
      position: absolute;
      top: 0px;
      left: 0px;
    }
  }

  .rank {
    margin-top: 20px;
    border-radius: 3px;
    border-top: none;
    background-color: #fff;
    .title {
      padding-top: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .left {
        display: flex;
        margin-left: 20px;
        align-items: center;
        & > img {
          width: 40px;
        }
        & > div {
          margin-left: 10px;
          color: #000;
          font-weight: 700;
          font-size: 18px;
        }
      }
      .more {
        color: #666;
        margin-right: 20px;
        cursor: pointer;
      }
    }
    .rank-list {
      display: flex;
      height: 216px;
      position: relative;

      .name-box {
        margin-top: 14px;
        font-size: 18px;
        text-align: center;
        display: inline-block;
        width: 80px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .price {
        font-size: 18px;
        color: #f12f2f;
      }
      //swiper---
      .swiper-container {
        width: 100%;
        margin-top: 16px;
        height: 200px;
        // margin-left: 40px;
        // margin-right: 40px;
        .swiper-slide {
          .item {
            margin: 20px;
            width: 100px;
            display: flex;
            flex-direction: column;
            align-items: center;
            color: #000;
            position: relative;
          }
          &:first-child {
            // margin-left: 20px;
            .img {
              border: 5px solid #ffb721;
            }
            .hat-box {
              width: 30px;
              height: 30px;
              line-height: 30px;
              text-align: center;
              border-radius: 50%;
              background-color: #f4f3f3;
              position: absolute;
              right: 6px;
              bottom: 64px;
              .hat {
                width: 24px;
              }
            }
          }
          &:nth-child(2) {
            .img {
              border: 5px solid #b8b3aa;
            }
            .hat-box {
              width: 30px;
              height: 30px;
              line-height: 30px;
              text-align: center;
              border-radius: 50%;
              background-color: #f4f3f3;
              position: absolute;
              right: 6px;
              bottom: 64px;

              .hat {
                width: 24px;
              }
            }
          }
          &:nth-child(3) {
            .img {
              border: 5px solid #906919;
            }
            .hat-box {
              width: 30px;
              height: 30px;
              line-height: 30px;
              text-align: center;
              border-radius: 50%;
              background-color: #f4f3f3;
              position: absolute;
              right: 6px;
              bottom: 64px;

              .hat {
                width: 24px;
              }
            }
          }
          .img {
            border: 5px solid #ccc;
            width: 90px;
          }
        }
      }

      /deep/.swiper-button-prev {
        color: var(--ThemeColor);
        position: absolute;
        top: 47%;
        left: 10px;
        z-index:3!important;
        opacity: 0;
      }

      /deep/.swiper-button-next {
        color: var(--ThemeColor);
        position: absolute;
        top: 47%;
        z-index:3!important;
        right: 10px;
        opacity: 0;
      }
      // .swiper-button-disabled {
      //   opacity: 0.35;
      // }
      .over {
        opacity: 1;
      }
    }
  }

  .statistics-userInfo {
    margin-top: 20px;
    height: 290px;
    display: flex;
    justify-content: space-between;
    .statistics {
      width: 58%;
      padding: 20px 0;
      background-color: #fff;
      border-radius: 3px;
      display: flex;
      flex-direction: column;
      .title {
        display: flex;
        justify-content: space-between;
        .title-left {
          display: flex;
          align-items: center;
          font-size: 18px;
          font-weight: 700;
          margin-left: 20px;
          color: #000;
          & > div {
            margin-left: 10px;
          }
        }
        .title-right {
          margin-right: 20px;
        }
      }
      .content {
        flex: 1;
        display: flex;
        justify-content: space-around;
        .item {
          color: #222;
          width: 260px;
          display: flex;
          align-items: center;
          border-radius: 3px;
          padding: 20px 0;

          .img-box {
            width: 40%;
            text-align: center;
            .img {
              width: 80%;
            }
          }

          .right {
            width: 60%;
            & > h3 {
              font-size: 20px;
              font-weight: 700;
            }
            & > p {
              margin-bottom: 0px;
              & > span {
                font-size: 30px;
                font-weight: 700;
              }
            }
          }
        }
      }
    }

    .userInfo {
      width: 40%;
      border-radius: 3px;
      border-top: none;
      background-color: #fff;
      display: flex;
      .item {
        margin-top: 20px;
        width: 50%;
        display: flex;
        border-left: 2px solid #ddd;
        flex-direction: column;
        align-items: center;
        color: #000;
        font-size: 12px;
        padding: 10px 10px;
        .name {
          font-size: 18px;
          color: var(--ThemeColor);
        }
      }
      .item-p {
        margin-top: 20px;
        flex: 1;
        .title {
          display: flex;
          align-items: center;
          margin-left: 20px;
          & > img {
            width: 40px;
          }
          & > div {
            margin-left: 10px;
            color: #000;
            font-weight: 700;
            font-size: 18px;
          }
        }
        .radar-box {
          height: 200px;
        }
      }
    }
  }

  .footer {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    .left {
      width: 58%;
      padding-top: 20px;
      border-radius: 3px;
      border-top: none;
      background-color: #fff;
      .title {
        display: flex;
        align-items: center;
        margin-left: 20px;
        & > img {
          width: 40px;
        }
        & > div {
          margin-left: 10px;
          color: #000;
          font-weight: 700;
          font-size: 18px;
        }
      }
      .echarts {
        height: 400px;
      }
    }
    .right {
      width: 40%;
      border-radius: 3px;
      border-top: none;
      background-color: #fff;
      .title {
        margin-top: 20px;

        display: flex;
        align-items: center;
        margin-left: 20px;
        & > img {
          width: 40px;
        }
        & > div {
          margin-left: 10px;
          color: #000;
          font-weight: 700;
          font-size: 18px;
        }
      }
      .content {
        padding: 10px 20px 20px;
        width: 100%;
        height: 400px;
        overflow-y: auto;
        overflow-x:hidden;
        .lookItem {
          // width: 90%;
          width: 100%;
          margin: 10px 0;
          height: 20px;
          display: flex;
          // border: 1px solid red;
          .itemListright{
            .shopName{
                // border: 1px solid red;
              // width: 80px;
              width:80%;
              height: 20;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              position: absolute;
              // right: -82px;
              right: -20%;
              top: 0;
              font-weight: 700;
              text-align: left;
            }
            
          }
          .itemList {
            min-width: 20px;
             height: 20px;
            cursor: pointer;
            position: relative;
            background: linear-gradient(to right, yellow, red);
            text-align: right;
            padding-right: 6px;
         
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1600px) {
  .statistics {
    h3 {
      font-size: 16px !important;
    }
    span {
      font-size: 22px !important;
    }
  }
}
@media screen and (min-width: 1400px) and (max-width: 1669px) {
}
</style>
